import RichTextAndIconBoxes from './richTextAndIconBoxes';

export default RichTextAndIconBoxes;
